import { useDispatch, useSelector } from 'react-redux';
import { useCallback } from 'react';
import {
  getChildrenDealerships,
  getCustomGroupsForDealership,
  getDealershipDepartments,
  getDealershipDetails,
  getDealershipID,
  getRulesForDealership,
  getTagsForDealership,
  showProgress,
  setRnpList,
} from '../../../redux/actions/DealershipActions';
import { apiEndpoints } from '../../../constants/apiEndpoints';
import service from '../../../apis/service';
import { ErrorToast } from '../../utils/Utils';

const useFetchDetails = () => {
  const dispatch = useDispatch();
  const dealershipDetails = useSelector((state) => state.DealershipDetails.dealershipdetails);

  const fetchDetails = async (id = null) => {
    dispatch(showProgress(true));
    const dealershipId = id ?? dealershipDetails?.id;

    const p1 = service.get(apiEndpoints.DEALER_BY_ID.replace('ID', dealershipId), '');
    const p2 = service.get(apiEndpoints.DEALER_DEPARTMENTS.replace('ID', dealershipId), '');
    const p3 = service.get(apiEndpoints.DEALER_CG.replace('ID', dealershipId), '');

    try {
      const responses = await Promise.all([p1, p2, p3]);
      dispatch(getDealershipID(dealershipId));
      dispatch(getDealershipDetails(responses[0]));
      dispatch(getDealershipDepartments('fetch', responses[1]));
      dispatch(getCustomGroupsForDealership(responses[2]));
    } catch (error) {
      ErrorToast(error);
    } finally {
      dispatch(showProgress(false));
    }
  };

  const fetchCgDetails = useCallback(
    async (id = null) => {
      dispatch(showProgress(true));
      const dealershipId = id ?? dealershipDetails?.id;

      try {
        const response = await service.get(apiEndpoints.DEALER_RULES.replace('ID', dealershipId));
        dispatch(getRulesForDealership(response));
      } catch (error) {
        ErrorToast(error);
      } finally {
        dispatch(showProgress(false));
      }
    },
    [dealershipDetails?.id, dispatch],
  );

  const fetchChildrenList = useCallback(
    async (dealershipId) => {
      try {
        const response = await service.get(apiEndpoints.DEALER_CHILDREN_LIST.replace('DEALER_ID', dealershipId));
        dispatch(getChildrenDealerships(response));
      } catch (error) {
        ErrorToast(error);
      }
    },
    [dispatch],
  );

  const fetchTags = useCallback(async () => {
    try {
      const responseTags = await service.get(apiEndpoints.DEALER_TAGS);
      dispatch(getTagsForDealership(responseTags));
    } catch (error) {
      ErrorToast(error);
    }
  }, [dispatch]);

  const fetchRnpList = async () => {
    dispatch(showProgress(true));
    await service
      .get(apiEndpoints.GET_RNP_LIST)
      .then((res) => {
        dispatch(setRnpList(res));
        dispatch(showProgress(false));
      })
      .catch((error) => {
        ErrorToast(error);
        dispatch(showProgress(false));
      });
  };

  return { fetchDetails, fetchTags, fetchChildrenList, fetchCgDetails, fetchRnpList };
};

export default useFetchDetails;
